import { render, staticRenderFns } from "./ColumnWithDataInside.vue?vue&type=template&id=3713b0d0&scoped=true&"
import script from "./ColumnWithDataInside.vue?vue&type=script&lang=js&"
export * from "./ColumnWithDataInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713b0d0",
  null
  
)

export default component.exports